<template>
  <div class="page-wrapper">
    <el-header class="page-header" height="auto">
      <el-form
        :inline="true"
        :model="searchParams"
        class="search-form"
        size="small"
      >
        <el-form-item label="公告标题">
          <el-input
            v-model="searchParams.title"
            placeholder="请输入公告标题"
            clearable
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="searchParams.status"
            placeholder="全部"
            clearable
            @change="handleSearch"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="未读" :value="2"></el-option>
            <el-option label="已读" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </el-header>

    <el-main class="page-main">
      <div class="table-container">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          height="100%"
          stripe
          :header-cell-style="{
            background: '#f8fafc',
            color: '#334155',
            fontWeight: '600',
            height: '48px'
          }"
        >
          <el-table-column
            prop="id"
            label="公告编号"
            align="center"
            min-width="180"
          ></el-table-column>
          <el-table-column
            prop="title"
            label="公告标题"
            align="center"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="type"
            label="公告类型"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <span
                class="status-tag status-success"
                v-if="scope.row.type === 1"
                >通知</span
              >
              <span class="status-tag status-info" v-else>公告</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <span
                class="status-tag status-success"
                v-if="scope.row.status === 1"
                >已读</span
              >
              <span class="status-tag status-info" v-else>未读</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sendTime"
            label="创建时间"
            align="center"
            min-width="180"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="viewDetail(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>

          <!-- 暂无数据 -->
          <template slot="empty">
            <el-empty description="暂无公告"></el-empty>
          </template>
        </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="pageNo"
          @current-change="handlePageChange"
        />
      </div>
    </el-main>

    <!-- 详情弹窗 -->
    <el-dialog
      :title="currentNotice.title"
      :visible.sync="detailVisible"
      width="600px"
      append-to-body
      custom-class="premium-dialog"
    >
      <div class="notice-detail-meta">
        <span>类型：{{ currentNotice.type === 1 ? "通知" : "公告" }}</span>
        <span>时间：{{ currentNotice.sendTime }}</span>
      </div>
      <div class="notice-detail-content" v-html="currentNotice.content"></div>
      <div
        v-if="attachments && attachments.length > 0"
        class="notice-attachments"
      >
        <div class="attachment-title">附件：</div>
        <div class="attachment-list">
          <div
            v-for="(file, index) in attachments"
            :key="index"
            class="attachment-item"
          >
            <i class="el-icon-document"></i>
            <a :href="file.url" target="_blank" class="attachment-link">{{
              file.fileName
            }}</a>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="detailVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMyBulletin, myBulletinDetail } from "@/api/student";

export default {
  name: "NoticeIndex",
  data() {
    return {
      loading: false,
      searchParams: {
        title: "",
        status: ""
      },
      tableData: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      detailVisible: false,
      currentNotice: {},
      attachments: []
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    handleSearch() {
      this.pageNo = 1;
      this.fetchList();
    },
    resetSearch() {
      this.searchParams = {
        title: "",
        status: ""
      };
      this.handleSearch();
    },
    async fetchList() {
      this.loading = true;
      try {
        let reqData = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          status: this.searchParams.status === "" ? 0 : this.searchParams.status
        };
        if (this.searchParams.title) {
          reqData.title = this.searchParams.title;
        }

        let resData = await getMyBulletin(reqData);

        // 兼容处理可能出现的字符串响应
        if (typeof resData === "string") {
          try {
            resData = JSON.parse(resData);
          } catch (e) {
            console.error("JSON parse error:", e);
          }
        }

        if (resData && (resData.code === 200 || resData.code === 0)) {
          const data = resData.data || {};
          this.tableData = data.records || [];
          this.total = data.total || 0;
        }
      } catch (e) {
        console.error("fetchList error:", e);
      } finally {
        this.loading = false;
      }
    },
    handlePageChange(page) {
      this.pageNo = page;
      this.fetchList();
    },
    async viewDetail(item) {
      try {
        let resData = await myBulletinDetail(item.id);
        if (typeof resData === "string") {
          try {
            resData = JSON.parse(resData);
          } catch (e) {
            console.error(e);
          }
        }

        if (resData && (resData.code === 200 || resData.code === 0)) {
          this.currentNotice = resData.data;
          try {
            this.attachments = JSON.parse(this.currentNotice.file || "[]");
          } catch (e) {
            this.attachments = [];
          }
          this.detailVisible = true;
          // 如果是未读，关闭弹窗后刷新列表以更新状态
          if (item.status === 2) {
            item.status = 1; // 先本地更新 UI
            this.$root.$emit("refresh-unread-count"); // 通知 Shell 刷新角标
          }
        }
      } catch (e) {
        this.$message.error("获取详情失败");
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/examination-page.scss";

.page-wrapper {
  background-color: #f5f7fa;
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  padding: 24px;
  box-sizing: border-box;
}

.page-header {
  background: #fff;
  border-radius: 12px;
  padding: 24px 24px 0 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

  .search-form {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
}

.page-main {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  overflow: hidden;

  .table-container {
    flex: 1;
    overflow: hidden;

    ::v-deep .el-table {
      border-radius: 8px;
      overflow: hidden;
      border: 1px solid #e2e8f0;

      &::before {
        display: none;
      }

      .el-table__cell {
        padding: 12px 0;
      }
    }
  }
}

.pagination-container {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

.status-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;

  &.status-success {
    background: #f0fdf4;
    color: #16a34a;
  }
  &.status-info {
    background: #f1f5f9;
    color: #64748b;
  }
}

/* 详情弹窗样式 */
.premium-dialog {
  border-radius: 16px;
  overflow: hidden;

  ::v-deep .el-dialog__header {
    background: #f8fafc;
    padding: 20px 24px;
    border-bottom: 1px solid #e2e8f0;

    .el-dialog__title {
      font-weight: 700;
      color: #1e293b;
      font-size: 17px;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
  }
}

.notice-detail-meta {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 13px;
}

.notice-detail-content {
  line-height: 1.8;
  color: #334155;
  min-height: 200px;
  ::v-deep img {
    max-width: 100%;
  }
}

.notice-attachments {
  margin-top: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;

  .attachment-title {
    font-weight: 600;
    color: #475569;
    margin-bottom: 12px;
    font-size: 14px;
  }

  .attachment-item {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }

    i {
      color: #64748b;
      font-size: 16px;
    }

    .attachment-link {
      color: #2563eb;
      text-decoration: none;
      font-size: 14px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
